import { Component, OnInit } from '@angular/core';
import { Form, FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { AssessorsService } from 'src/app/services/assessors.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin, from, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TosterService } from 'src/app/services/toster.service';
import { LocationService } from 'src/app/services/location.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ApplicantService } from 'src/app/services/applicant.service';
import { noWhitespaceValidator } from 'src/shared/whitespace.validator';
@Component({
  selector: 'app-assessors',
  templateUrl: './assessors.component.html',
  styleUrls: ['./assessors.component.css'],
})
export class AssessorsComponent implements OnInit {
  assessorsForm!: FormGroup;
  isValidFormSubmitted: boolean = false;
  id: any;
  udata: any;
  applicantSdata: any = [];
  districtdata: any;
  statedata: any;
  getdistrictApplicant: any;
  districtdataApplicant: any;
  districtdataOffice: any;
  exp_array: any = [];
  SectorCurrdropdownList: any = [];
  SectorPrevdropdownList: any = [];
  SectordropdownList: any = [];
  ExpodropdownList: any = [];
  ExpdropdownList: any = [];
  completedAll: boolean = false;
  selectedItems: any = [];
  eselectedItems: any = [];
  secselectedItems: any = [];
  secpselectedItems: any = [];
  seccselectedItems: any = [];
  dropdownSettings: IDropdownSettings = {};
  firstNameValue: any = '';
  dobValue: any = '';
  FinalError: any = { errMsg: '', status: false };
  countrydata: any;
  statedata2: any;
  editStatus: any;
  refreshCount: number = 0;
  constructor(
    private fb: FormBuilder,
    private assessorss: AssessorsService,
    private router: Router,
    private _Activatedroute: ActivatedRoute,
    private toast: TosterService,
    private locationS: LocationService,
    private applicantS: ApplicantService,
    private spinner: NgxSpinnerService
  ) { }
  getValues(e: any, field: any) {
    if (field == 'dob') {
      this.dobValue = e.target.value;
    } else {
      this.dobValue = e;
    }
  }
  getValuesName(e: any, field: any) {
    if (field == 'name') {
      this.firstNameValue = e.target.value;
    } else {
      this.firstNameValue = e;
    }
  }
  ngOnInit(): void {
    this.spinner.show();
    // this.onforminit()
    for (let n = 1; n < 45; ++n) {
      this.ExpdropdownList.push({ item_text: n });
    }
    this.ExpodropdownList = [
      { item_text: 'TQM' },
      { item_text: 'TPM' },
      { item_text: 'Six Sigma' },
      { item_text: 'Business Excellence' },
      { item_text: 'Improvement Initiatives' },
    ];
    this.selectedItems = [];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_text',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
    };
    this.udata = localStorage.getItem('userdata');
    this.udata = JSON.parse(this.udata);
    this.id = this.udata._id;
    if (this.udata.role == 'assessor') {
      /*
         this.editStatus = true;
         this.applicantS.getSector().subscribe((items: any) => {
           items.result.map((item: any) => {
             this.SectordropdownList.push({ item_text: item });
             this.SectorPrevdropdownList.push({ item_text: item });
             this.SectorCurrdropdownList.push({ item_text: item });
           });
         });
         
         this.assessorss
           .GetAssessorSingle(this.udata._id)
           .subscribe((data: any) => {
             
             this.applicantSdata = data.applicanData;
             this.onforminit(this.applicantSdata);
             this.secselectedItems = this.applicantSdata.domain;
             this.selectedItems = this.applicantSdata.exposure;
             this.seccselectedItems =
               this.applicantSdata.organizationProductservice;
             this.secpselectedItems =
               this.applicantSdata.organizationProductservice2;
             this.getValuesName(this.applicantSdata.firstName, '');
             this.getValues(this.applicantSdata.assessorsDate, '');
             this.getStateByCountryName(
               this.applicantSdata.residentialCountry,
               ''
             );
             this.getStateByCountryName2(
               this.applicantSdata.organizationCountry,
               ''
             );
             
           });
      */
      this.editStatus = true;
      this.applicantS.getSector().subscribe((items: any) => {
        this.seccselectedItems = items.result;
        const observables = items.result.map((item: any) => {
          this.SectordropdownList.push({ item_text: item });
          this.SectorPrevdropdownList.push({ item_text: item });
          this.SectorCurrdropdownList.push({ item_text: item });
          return of(null); // Use 'of' to create an observable that emits a null value
        });
        forkJoin(observables)
          .pipe(
            tap(() => {
              this.assessorss
                .GetAssessorSingle(this.udata._id)
                .subscribe((data: any) => {
                  this.applicantSdata = data.applicanData;
                  this.secselectedItems = this.applicantSdata.domain;
                  this.selectedItems = this.applicantSdata.exposure;
                  this.seccselectedItems =
                    this.applicantSdata.organizationProductservice;
                  this.secpselectedItems =
                    this.applicantSdata.organizationProductservice2;
                  this.onforminit(this.applicantSdata);
                  this.getValuesName(this.applicantSdata.firstName, '');
                  this.getValues(this.applicantSdata.assessorsDate, '');
                  this.getStateByCountryName(
                    this.applicantSdata.residentialCountry,
                    ''
                  );
                  this.getStateByCountryName2(
                    this.applicantSdata.organizationCountry,
                    ''
                  );
                });
            })
          )
          .subscribe();
      });
    } else {
      this.applicantS.getSector().subscribe((items: any) => {
        this.seccselectedItems = items.result;
        items.result.map((item: any) => {
          this.SectordropdownList.push({ item_text: item });
          this.SectorPrevdropdownList.push({ item_text: item });
          this.SectorCurrdropdownList.push({ item_text: item });
        });
        if (this._Activatedroute.snapshot.paramMap.get('id')) {
          this.editStatus = false;
          this.assessorss
            .GetAssessorSingle(
              this._Activatedroute.snapshot.paramMap.get('id')
            )
            .subscribe((data: any) => {
              this.applicantSdata = data.applicanData;
              this.secselectedItems = this.applicantSdata.domain;
              this.selectedItems = this.applicantSdata.exposure;
              this.seccselectedItems =
                this.applicantSdata.organizationProductservice;
              this.secpselectedItems =
                this.applicantSdata.organizationProductservice2;
              this.onforminit(this.applicantSdata);
              this.getValuesName(this.applicantSdata.firstName, '');
              this.getValues(this.applicantSdata.assessorsDate, '');
              this.getStateByCountryName(
                this.applicantSdata.residentialCountry,
                ''
              );
              this.getStateByCountryName2(
                this.applicantSdata.organizationCountry,
                ''
              );
            });
        }
        else {
          this.editStatus = true;
          this.secselectedItems = [];
          this.selectedItems = [];
          this.seccselectedItems = [];
          this.secpselectedItems = [];
          this.onforminit(this.applicantSdata);
        }
      });
    }
    this.locationS.getAllCountries().subscribe((data: any) => {
      this.countrydata = data;
    });
    // this.locationS.getallstates().subscribe((data: any) => {
    //   this.statedata = data.result;
    // });
    this.spinner.hide();
  }
  ngAfterViewInit() {
    this.completedAll = true;
  }
  getStateByCountryName(country: any, f: any) {
    let countryVal = f == 'sett' ? country.target.value : country;
    this.locationS.getStateByCountry(countryVal).subscribe((items: any) => {
      this.statedata = items[0]?.states;
    });
  }
  getStateByCountryName2(country: any, f: any) {
    let countryVal = f == 'sett' ? country.target.value : country;
    this.locationS.getStateByCountry(countryVal).subscribe((items: any) => {
      this.statedata2 = items[0]?.states;
    });
  }
  public get f() {
    return this.assessorsForm?.controls;
  }
  onItemSelectDropDown(item: any, dropdownName: any) {
    if (dropdownName == 'domain') {
      this.secselectedItems.push(item);
    } else if (dropdownName == 'exposure') {
      this.selectedItems.push(item);
    } else if (dropdownName == 'organizationProductservice') {
      this.seccselectedItems.push(item);
    } else {
      this.secpselectedItems.push(item);
    }
  }
  onforminit(r: any) {
    this.assessorsForm = this.fb.group({
      fail: [undefined],
      firstName: [r.firstName],
      assessorsDate: [r.assessorsDate],
      designation: [r.designation],
      assessorsEmail: [r.assessorsEmail],
      assessorsSecondaryemail: [r.assessorsSecondaryemail],
      assessorsTertiaryemail: [r.assessorsTertiaryemail],
      assessorsPhone: [r.assessorsPhone],
      assessorsAlternateno: [r.assessorsAlternateno],
      assessorsEducation: [r.assessorsEducation],
      residentialAddressline: [r.residentialAddressline],
      residentialCountry: [r.residentialCountry],
      residentialState: [r.residentialState],
      residentialCity: [r.residentialCity],
      residentialZipcode: [r.residentialZipcode],
      organizationAddressline1: [r.organizationAddressline1],
      organizationCountry: [r.organizationCountry],
      organizationState: [r.organizationState],
      organizationCity: [r.organizationCity],
      organizationZipcode: [r.organizationZipcode],
      zone: [r.zone],
      OrganizationLocation: [r.OrganizationLocation],
      batch: [r.batch],
      Organization: [r.Organization],
      organizationDesignation: [r.organizationDesignation],
      organizationProductservice: [
        this.udata && this.udata.role == 'assessor' ? this.secpselectedItems : ''
      ],
      Organization2: [r.Organization2],
      organizationDesignation2: [r.organizationDesignation2],
      organizationProductservice2: [
        this.udata && this.udata.role == 'assessor' ? this.seccselectedItems : ''
      ],
      org_Fullname: [r.org_Fullname],
      report_Designation: [r.report_Designation],
      fsmsCertificate: [r.fsmsCertificate],
      exposure: [this.udata && this.udata.role == 'assessor' ? this.selectedItems : ''],
      experience: [r.experience],
      skill: [r.skill],
      org_Email: [
        r.org_Email,
        [Validators.pattern('^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$')],
      ],
      assessorsFsmsqualified: [r.assessorsFsmsqualified],
      domain: [this.udata && this.udata.role == 'assessor' ? this.secselectedItems : ''],
      assessorsTraining: [r.assessorsTraining],
      code1: [r.code1],
      code2: [r.code2],
    });
  }
  duplicateArr(arr: any, comp: any = 'item_text') {
    const unique = arr
      .map((e: any) => e[comp])
      .map((e: any, i: any, final: any) => final.indexOf(e) === i && i)
      .filter((e: any) => arr[e])
      .map((e: any) => arr[e]);
    return unique;
  }
  clickFunction() {
    this.isValidFormSubmitted = false;
    if (this.assessorsForm.invalid) {
      this.isValidFormSubmitted = true;
      this.FinalError.errMsg = 'Please check the highlighted fields. Also ensure the validity of them.';
      this.FinalError.status = true;
    } else {
      this.FinalError.errMsg = '';
      this.FinalError.status = false;
      this.assessorsForm.value.assessorsDate = this.dobValue;
      this.assessorsForm.value.firstName = this.firstNameValue;
      this.assessorsForm.value['domain'] = this.duplicateArr(
        this.secselectedItems
      );
      this.assessorsForm.value.exposure = this.duplicateArr(this.selectedItems);
      this.assessorsForm.value.organizationProductservice = this.duplicateArr(
        this.seccselectedItems
      );
      this.assessorsForm.value.organizationProductservice2 = this.duplicateArr(
        this.secpselectedItems
      );
      if (this.udata.role == 'assessor') {
        this.assessorss
          .updateAssessors(this.assessorsForm.value, this.id)
          .subscribe((data: any) => {
            this.toast.showSuccess(
              'Congratulation!, Assessors has been updated.'
            );
          });
      } else {
        if (this._Activatedroute.snapshot.paramMap.get('id')) {
          this.assessorss
            .updateAssessors(
              this.assessorsForm.value,
              this._Activatedroute.snapshot.paramMap.get('id')
            )
            .subscribe((data: any) => {
              this.toast.showSuccess(
                'Congratulation!, Assessors has been updated.'
              );
            });
        }
        else {
          this.assessorss
            .addAssessor(this.assessorsForm.value)
            .subscribe((data: any) => {
              this.toast.showSuccess(
                'Congratulation!, Assessors has been Added.'
              );
            });
        }
      }
      // window.location.reload();
    }
  }
  getdistrict(e: any) {
    this.locationS
      .getalldistrictwithstatewise({
        statename: e.target.value,
      })
      .subscribe((data: any) => {
        this.districtdata = data.result;
      });
  }
  getdistrictonload(state: any) {
    this.locationS
      .getalldistrictwithstatewise({
        statename: state,
      })
      .subscribe((data: any) => {
        this.districtdata = data.result;
      });
  }
  getdistrictResidential(e: any) {
    this.locationS
      .getalldistrictwithstatewise({
        statename: e.target.value,
      })
      .subscribe((data: any) => {
        this.getdistrictApplicant = data.result;
      });
  }
  getdistrictonloadResidential(residentialState: any) {
    this.locationS
      .getalldistrictwithstatewise({
        statename: residentialState,
      })
      .subscribe((data: any) => {
        this.getdistrictApplicant = data.result;
      });
  }
  getdistrictOffice(e: any) {
    this.locationS
      .getalldistrictwithstatewise({
        statename: e.target.value,
      })
      .subscribe((data: any) => {
        this.districtdataOffice = data.result;
      });
  }
  getdistrictonloadContact(organizationState: any) {
    this.locationS
      .getalldistrictwithstatewise({
        statename: organizationState,
      })
      .subscribe((data: any) => {
        this.districtdataOffice = data.result;
      });
  }
  finalsave() {
    this.f['firstName'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['assessorsDate'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['designation'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['assessorsEmail'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['assessorsSecondaryemail'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['assessorsPhone'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['assessorsAlternateno'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['assessorsEducation'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['residentialAddressline'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['residentialCountry'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['residentialState'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['residentialCity'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['residentialZipcode'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['organizationAddressline1'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['organizationCountry'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['organizationState'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['organizationCity'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['organizationZipcode'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['zone'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['OrganizationLocation'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['batch'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['Organization'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['organizationDesignation'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['organizationProductservice'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['Organization2'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['organizationDesignation2'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['org_Fullname'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['report_Designation'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['fsmsCertificate'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['exposure'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['experience'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['skill'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['org_Email'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['assessorsFsmsqualified'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['domain'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['assessorsTraining'].setValidators([Validators.required, noWhitespaceValidator]);
    this.f['firstName'].updateValueAndValidity();
    this.f['assessorsDate'].updateValueAndValidity();
    this.f['designation'].updateValueAndValidity();
    this.f['assessorsEmail'].updateValueAndValidity();
    this.f['assessorsSecondaryemail'].updateValueAndValidity();
    this.f['assessorsPhone'].updateValueAndValidity();
    this.f['assessorsAlternateno'].updateValueAndValidity();
    this.f['assessorsEducation'].updateValueAndValidity();
    this.f['residentialAddressline'].updateValueAndValidity();
    this.f['residentialCountry'].updateValueAndValidity();
    this.f['residentialState'].updateValueAndValidity();
    this.f['residentialCity'].updateValueAndValidity();
    this.f['residentialZipcode'].updateValueAndValidity();
    this.f['organizationAddressline1'].updateValueAndValidity();
    this.f['organizationCountry'].updateValueAndValidity();
    this.f['organizationState'].updateValueAndValidity();
    this.f['organizationCity'].updateValueAndValidity();
    this.f['organizationZipcode'].updateValueAndValidity();
    this.f['zone'].updateValueAndValidity();
    this.f['OrganizationLocation'].updateValueAndValidity();
    this.f['batch'].updateValueAndValidity();
    this.f['Organization'].updateValueAndValidity();
    this.f['organizationDesignation'].updateValueAndValidity();
    this.f['organizationProductservice'].updateValueAndValidity();
    this.f['Organization2'].updateValueAndValidity();
    this.f['organizationDesignation2'].updateValueAndValidity();
    this.f['org_Fullname'].updateValueAndValidity();
    this.f['report_Designation'].updateValueAndValidity();
    this.f['fsmsCertificate'].updateValueAndValidity();
    this.f['exposure'].updateValueAndValidity();
    this.f['experience'].updateValueAndValidity();
    this.f['skill'].updateValueAndValidity();
    this.f['org_Email'].updateValueAndValidity();
    this.f['assessorsFsmsqualified'].updateValueAndValidity();
    this.f['domain'].updateValueAndValidity();
    this.f['assessorsTraining'].updateValueAndValidity();
  }
  removeValidators() {
    this.f['firstName'].clearValidators();
    this.f['assessorsDate'].clearValidators();
    this.f['designation'].clearValidators();
    this.f['assessorsEmail'].clearValidators();
    this.f['assessorsSecondaryemail'].clearValidators();
    this.f['assessorsPhone'].clearValidators();
    this.f['assessorsAlternateno'].clearValidators();
    this.f['assessorsEducation'].clearValidators();
    this.f['residentialAddressline'].clearValidators();
    this.f['residentialCountry'].clearValidators();
    this.f['residentialState'].clearValidators();
    this.f['residentialCity'].clearValidators();
    this.f['residentialZipcode'].clearValidators();
    this.f['organizationAddressline1'].clearValidators();
    this.f['organizationCountry'].clearValidators();
    this.f['organizationState'].clearValidators();
    this.f['organizationCity'].clearValidators();
    this.f['organizationZipcode'].clearValidators();
    this.f['zone'].clearValidators();
    this.f['OrganizationLocation'].clearValidators();
    this.f['batch'].clearValidators();
    this.f['Organization'].clearValidators();
    this.f['organizationDesignation'].clearValidators();
    this.f['organizationProductservice'].clearValidators();
    this.f['Organization2'].clearValidators();
    this.f['organizationDesignation2'].clearValidators();
    this.f['org_Fullname'].clearValidators();
    this.f['report_Designation'].clearValidators();
    this.f['fsmsCertificate'].clearValidators();
    this.f['exposure'].clearValidators();
    this.f['experience'].clearValidators();
    this.f['skill'].clearValidators();
    this.f['org_Email'].clearValidators();
    this.f['assessorsFsmsqualified'].clearValidators();
    this.f['domain'].clearValidators();
    this.f['assessorsTraining'].clearValidators();
    this.f['firstName'].updateValueAndValidity();
    this.f['assessorsDate'].updateValueAndValidity();
    this.f['designation'].updateValueAndValidity();
    this.f['assessorsEmail'].updateValueAndValidity();
    this.f['assessorsSecondaryemail'].updateValueAndValidity();
    this.f['assessorsPhone'].updateValueAndValidity();
    this.f['assessorsAlternateno'].updateValueAndValidity();
    this.f['assessorsEducation'].updateValueAndValidity();
    this.f['residentialAddressline'].updateValueAndValidity();
    this.f['residentialCountry'].updateValueAndValidity();
    this.f['residentialState'].updateValueAndValidity();
    this.f['residentialCity'].updateValueAndValidity();
    this.f['residentialZipcode'].updateValueAndValidity();
    this.f['organizationAddressline1'].updateValueAndValidity();
    this.f['organizationCountry'].updateValueAndValidity();
    this.f['organizationState'].updateValueAndValidity();
    this.f['organizationCity'].updateValueAndValidity();
    this.f['organizationZipcode'].updateValueAndValidity();
    this.f['zone'].updateValueAndValidity();
    this.f['OrganizationLocation'].updateValueAndValidity();
    this.f['batch'].updateValueAndValidity();
    this.f['Organization'].updateValueAndValidity();
    this.f['organizationDesignation'].updateValueAndValidity();
    this.f['organizationProductservice'].updateValueAndValidity();
    this.f['Organization2'].updateValueAndValidity();
    this.f['organizationDesignation2'].updateValueAndValidity();
    this.f['org_Fullname'].updateValueAndValidity();
    this.f['report_Designation'].updateValueAndValidity();
    this.f['fsmsCertificate'].updateValueAndValidity();
    this.f['exposure'].updateValueAndValidity();
    this.f['experience'].updateValueAndValidity();
    this.f['skill'].updateValueAndValidity();
    this.f['org_Email'].updateValueAndValidity();
    this.f['assessorsFsmsqualified'].updateValueAndValidity();
    this.f['domain'].updateValueAndValidity();
    this.f['assessorsTraining'].updateValueAndValidity();
  }
}
